exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-nav-global-notice-vs .yxtf-dialog{max-width:680px !important}\n", ""]);

